module.exports = __webpack_public_path__ + "img/mango-4.ff1e39e0.png";